import find from "lodash/find";

export class CMVRCenterService {
  constructor($resource, ApiService) {
    "ngInject";

    this.$resource = $resource;
    this.apiService = ApiService;

    // endpoint
    const endpoint = this.apiService.getResourceUrl(
      "/cmvr-centers/:cmvrCenterId"
    );
    // CMVR Center CRUD
    this.resource = this.$resource(endpoint, null, {
      query: { method: "get", cancellable: true },
      create: { method: "post" },
      update: { method: "put" },
    });
    this.cmvrCenterVeteransCountEndpoint = this.apiService.getResourceUrl(
      "/cmvr-centers/:cmvrCenterId/veterans-count"
    );
    this.cmvrCenterVeteransCountResource = this.$resource(
      this.cmvrCenterVeteransCountEndpoint
    );
    this.cmvrCenterListQuery = null;
  }
  addCMVRCenter(details) {
    return this.resource.create(details).$promise;
  }
  updateCMVRCenter(cmvrCenterId, details) {
    return this.resource.update({ cmvrCenterId }, details).$promise;
  }
  deleteCMVRCenter(cmvrCenterId) {
    return this.resource.delete({ cmvrCenterId }).$promise;
  }
  getCMVRCenterList(pageId, limit, searchKeyword) {
    if (this.cmvrCenterListQuery) {
      this.cmvrCenterListQuery.$cancelRequest();
    }
    this.cmvrCenterListQuery = this.resource.query({
      pageId: pageId || 1,
      limit: limit || 10,
      searchKeyword: searchKeyword || undefined,
    });
    return this.cmvrCenterListQuery.$promise;
  }
  getCMVRCenterDetails(cmvrCenterId) {
    return this.resource.get({ cmvrCenterId }).$promise;
  }
  getVeteransCountInCMVRCenter(cmvrCenterId) {
    return this.cmvrCenterVeteransCountResource.get({ cmvrCenterId }).$promise;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/cmvr-center/cmvr-center.service.js